import React from "react";
import "./HomePage.css";

const PrivacyPolicy = () => (
  <div className="privacy-policy">
    <h4>Privacy Policy</h4>
    <p>
      Give Stream is committed to protecting your privacy. This Privacy Policy
      explains how we collect, use, and disclose your personal information.
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      We collect information you provide directly to us, such as your name,
      email address, and payment information. We also collect information
      automatically, such as your IP address and browsing behavior.
    </p>

    <h2>2. Use of Information</h2>
    <p>
      We use your information to provide, maintain, and improve our services,
      process donations, and communicate with you.
    </p>

    <h2>3. Sharing of Information</h2>
    <p>
      We do not share your personal information with third parties except as
      necessary to provide our services, comply with the law, or protect our
      rights.
    </p>

    <h2>4. Data Security</h2>
    <p>
      We implement reasonable security measures to protect your personal
      information from unauthorized access and use.
    </p>

    <h2>5. Your Rights</h2>
    <p>
      You have the right to access, correct, or delete your personal
      information. You can also object to or restrict our processing of your
      information.
    </p>

    <h2>6. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of
      any changes by posting the new policy on our platform.
    </p>

    <h2>7. Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at
      [info@givestream.com].
    </p>
  </div>
);

export default PrivacyPolicy;
